import { render, staticRenderFns } from "./TextItem.vue?vue&type=template&id=89e6f642&"
import script from "./TextItem.vue?vue&type=script&lang=js&"
export * from "./TextItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-mobile-web/cafe-mobile-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89e6f642')) {
      api.createRecord('89e6f642', component.options)
    } else {
      api.reload('89e6f642', component.options)
    }
    module.hot.accept("./TextItem.vue?vue&type=template&id=89e6f642&", function () {
      api.rerender('89e6f642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/article_widget/components/TextItem.vue"
export default component.exports